import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Grid, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import AddCommentIcon from '@material-ui/icons/AddComment'
import PhotoIcon from '@material-ui/icons/Photo'
import EditIcon from '@material-ui/icons/Edit'
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'

import useRouter from 'utils/useRouter'
import { useAuth } from 'hooks/useAuth'
import { CustomButton } from 'components/CustomButton'
import { ModalGerenciarAcesso } from 'components/ModalGerenciarAcesso'
import useStyles from './MenuAcoes.styles'

export const MenuAcoes = (props) => {
  const { local } = props
  const classes = useStyles()
  const router = useRouter()
  const { currentUser } = useAuth()

  const [anchorEl, setAnchorEl] = useState(null)
  const [isGerenciarAcessoOpen, setIsGerenciarAcessoOpen] = useState(false)

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuBotaoAcoes = (to) => {
    handleClose()
    router.history.push(to)
  }

  const handleClickAdicionarInformacao = useCallback(() => {
    handleClose()
    router.history.push(`/local/adicionarInformacao/${local.id}`)
  }, [local.id, router])

  return (
    <Grid container alignItems="center" className={classes.actionsContainer}>
      <CustomButton
        colorType="primary"
        variant="contained"
        onClick={handleClickBotaoAcoes}
        endIcon={<ArrowDropDownIcon />}
      >
        Ações
      </CustomButton>

      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/local/editarLocal/${local.id}`)}>
          <ListItemIcon className={classes.menuIcon}>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Editar local" />
        </MenuItem>

        <MenuItem onClick={handleClickAdicionarInformacao}>
          <ListItemIcon className={classes.menuIcon}>
            <AddCommentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Adicionar Informação" />
        </MenuItem>

        <MenuItem onClick={() => handleMenuBotaoAcoes(`/galeria/local/${local.id}`)}>
          <ListItemIcon className={classes.menuIcon}>
            <PhotoIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Ver galeria" />
        </MenuItem>

        {currentUser.cargo?.id === 1 && (
          <MenuItem onClick={() => { handleClose(); setIsGerenciarAcessoOpen(true) }}>
            <ListItemIcon className={classes.menuIcon}>
              <SupervisedUserCircleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Conceder acesso à galeria" />
          </MenuItem>
        )}
      </Menu>

      <ModalGerenciarAcesso
        open={isGerenciarAcessoOpen}
        onClose={() => setIsGerenciarAcessoOpen(false)}
        idCaso={local.id_caso}
        usuarios={[]}
        selecionados={[]}
      />
    </Grid>
  )
}

MenuAcoes.propTypes = {
  local: PropTypes.object.isRequired,
}
